import { Layout, Page, ContextualSaveBar } from "@shopify/polaris";
import { useRef, useEffect } from "react";
import { useHistory } from "react-router";
import { useMutation } from "react-query";
import { createOneCustomer } from "api";
import { useSnackbar } from "providers";
import { nanoid } from "nanoid";
import { SharedForm } from "../SharedForm/SharedForm";

export function NewCustomer(props) {
  const skipToContentRef = useRef(null);
  const history = useHistory();

  const initialValues = useRef({
    isDetail: false,
    tckn: "",
    birthDate: "",
    address: "",
    meslek: "",
    yakini: "",
    yakinTel: "",
    alerjiDurumu: "",
    kanGrubu: "",
    gozlukLensDurumu: "",
    doktorRaporuTarihi: "",
    doktorRaporuKurum: "",
    referans: "",
    memberType: "",
    name: "",
    email: "",
    mainEducator: "",
    backupEducator: "",
    horse: "",
    tel: "",
    password: nanoid(6),
    avatar: undefined,
    permissions: { sms: true, email: true, call: true },
    status: "Aktif",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { toggleSnack } = useSnackbar();

  const postMutation = useMutation(createOneCustomer);

  const onSubmitHandler = (values) => {
    postMutation.mutate(values, {
      onSuccess: (response) => {
        toggleSnack({
          key: "newCustomerSuccess",
          message: "Üye kaydı başarıyla oluşturulmuştur",
          active: true,
        });

        history.push("/customers");
      },
      onError: (error) => {
        toggleSnack({
          key: "newCustomerError",
          error: true,
          message: error?.response?.data?.message,
          active: true,
        });
      },
    });
  };

  return (
    <Page
      title="Yeni Üye"
      narrowWidth={true}
      breadcrumbs={[{ content: "Üyeler", url: "/customers" }]}
    >
      <Layout>
        <a id="SkipToContentTarget" ref={skipToContentRef} tabIndex={-1} />
        <SharedForm
          onSubmit={onSubmitHandler}
          initialValues={initialValues.current}
          savebarRender={(values) => (
            <Savebar {...values} isLoading={postMutation.isLoading} />
          )}
        />
      </Layout>
    </Page>
  );
}

function Savebar({ handleSubmit, isValid, isLoading }) {
  const history = useHistory();
  return (
    <ContextualSaveBar
      saveAction={{
        onAction: handleSubmit,
        loading: isLoading,
        disabled: !isValid,
        content: "Kaydet",
      }}
      message="Yeni Üye"
      discardAction={{
        onAction: () => history.push("/customers"),
        content: "Geri",
      }}
    />
  );
}
